/** @file An entity-relative point made absolute: plus the entity position, itself rounded (design 21.4). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';
import { snapRelOf } from '@zilo/pose3d-render-core/place/snapRelOf';

/** `snapRelOf(entityPos) + rel`; `rel` is taken as given (already rounded, or deliberately not, 21.4 rule 3). */
export function entityPointOf(rel: Vec3, entityPos: Vec3, view: View): Vec3 {
  const e = snapRelOf(entityPos, view);
  return [e[0] + rel[0], e[1] + rel[1], e[2] + rel[2]];
}
